// Japanese translations
export const ja: Record<string, string> = {
  // Main Menu
  'menu.dashboard': 'ダッシュボード',
  'menu.orderNew': '製品登録',
  'menu.deliveryList': '配送リスト',
  'menu.delivery': '配送',
  'menu.receipt': 'レシート/ラベル印刷',
  'menu.definitions': '定義',
  'menu.customers': '顧客',
  'menu.products': '製品定義',
  'menu.pricing': '価格定義',
  'menu.tailoring': '仕立て作業',
  'menu.attributes': '製品属性',
  'menu.users': 'ユーザー',
  'menu.productOrdering': '製品順序',
  'menu.discounts': '割引定義',
  'menu.settings': '設定',
  'menu.generalSettings': '一般設定',
  'menu.permissions': '権限管理',
  'menu.subscription': 'サブスクリプション',
  'menu.invoices': '請求書管理',
  'menu.expenses': '経費入力',
  'menu.zReport': 'Z Report',
  'menu.reportsAndAccounting': 'レポート・会計',
  'menu.systemAndCommunication': 'システム・連絡',
  'menu.reportsList': 'レシート一覧',
  'menu.accountStatement': '口座明細',
  'menu.tickets': 'サポートリクエスト',
  'menu.support': 'サポート',
  'menu.profile': 'プロフィール',
  'menu.logout': 'ログアウト',
  'menu.notifications': 'SMS/WhatsApp通知',
  'menu.whatsappConnection': 'WhatsApp接続',
  'menu.smsConnection': 'SMS接続',
  
  // Dashboard
  'dashboard.title': 'ダッシュボード',
  'dashboard.todaySales': '本日の売上',
  'dashboard.totalOrders': '総注文数',
  'dashboard.pendingDeliveries': '配送保留中',
  'dashboard.activeCustomers': 'アクティブ顧客',
  'dashboard.recentOrders': '最近の注文',
  'dashboard.viewAll': 'すべて表示',
  'dashboard.quickActions': 'クイックアクション',
  'dashboard.newOrder': '新規注文',
  'dashboard.newCustomer': '新規顧客',
  'dashboard.deliveries': '配送',
  'dashboard.reports': 'レポート',
  'dashboard.today': '今日',
  'dashboard.yesterday': '昨日',
  'dashboard.week': '週',
  'dashboard.month': '月',
  'dashboard.quarter': '四半期',
  'dashboard.year': '年',
  'dashboard.totalRevenue': '総収益',
  'dashboard.totalOrdersCard': '総注文数',
  'dashboard.totalPieces': '総アイテム数',
  'dashboard.cancelled': 'キャンセル済み',
  'dashboard.inProcess': '処理中',
  'dashboard.inProcessDesc': '処理中の注文',
  'dashboard.ready': '準備完了',
  'dashboard.readyDesc': '配送準備完了の注文',
  'dashboard.delivered': '配送完了',
  'dashboard.deliveredDesc': '完了した注文',
  'dashboard.announcements': 'お知らせ',
  'dashboard.announcementAll': '一般',
  'dashboard.announcementPrivate': 'プライベート',
  
  // Order Entry
  'order.title': '新規注文',
  'order.customer': '顧客',
  'order.selectCustomer': '顧客を選択',
  'order.newCustomer': '新規顧客',
  'order.products': '製品',
  'order.addProduct': '製品を追加',
  'order.selectProduct': '製品を選択',
  'order.quantity': '数量',
  'order.price': '価格',
  'order.total': '合計',
  'order.discount': '割引',
  'order.subtotal': '小計',
  'order.tax': '消費税',
  'order.grandTotal': '総合計',
  'order.payment': '支払い',
  'order.paymentMethod': '支払い方法',
  'order.cash': '現金',
  'order.card': 'クレジットカード',
  'order.credit': '掛け売り',
  'order.amountPaid': '支払額',
  'order.remainingBalance': '残高',
  'order.deliveryDate': '配送日',
  'order.notes': 'メモ',
  'order.createOrder': '注文を作成',
  'order.cancel': 'キャンセル',
  
  // Users
  'users.title': 'ユーザー',
  'users.addNew': '新規ユーザー',
  'users.name': '名前',
  'users.email': 'メール',
  'users.role': '役割',
  'users.pin': 'PIN',
  'users.permissions': '権限',
  'users.allPermissions': 'すべての権限',
  'users.permissionCount': '{count} 権限',
  'users.changePin': 'PINを変更',
  'users.edit': '編集',
  'users.delete': '削除',
  'users.newUser': '新規ユーザー',
  'users.editUser': 'ユーザーを編集',
  'users.editingUser': '{name} を編集中',
  'users.deleteUserTitle': 'ユーザーを削除',
  'users.deletingUser': '{name} を削除してもよろしいですか？',
  'users.pinCode': 'PINコード（4-6桁）',
  'users.selectRole': '役割を選択',
  'users.patron': 'オーナー',
  'users.kasiyer': 'レジ係',
  'users.sofor': 'ドライバー',
  'users.eleman': 'スタッフ',
  'users.changePinTitle': 'PINコードを変更',
  'users.newPin': '新しいPINコード',
  'users.confirmPin': 'PINコードを確認',
  'users.pinMismatch': 'PINコードが一致しません',
  'users.pinRequired': 'PINコードが必要です',
  'users.pinLength': 'PINコードは4-6桁である必要があります',
  'users.changingPinFor': '{name} のPINを変更中',
  
  // Products
  'products.title': '製品定義',
  'products.addNew': '新規製品',
  'products.category': 'カテゴリー',
  'products.name': '製品名',
  'products.price': '価格',
  'products.color': '色',
  'products.active': 'アクティブ',
  'products.actions': 'アクション',
  'products.search': '製品を検索...',
  'products.noProducts': '製品が見つかりません',
  'products.noCategoryProducts': 'このカテゴリーに製品がありません',
  'products.emptyCart': 'カートが空です',
  
  // Service Types
  'service.tailor': '仕立て',
  'service.dryCleaning': 'ドライクリーニング',
  'service.washing': '洗濯',
  'service.ironing': 'アイロン',
  'service.shoeShine': '靴磨き',
  'service.carpet': 'カーペット',
  'service.tailoring': '仕立て修正',
  'service.carpetWashing': 'カーペット洗浄',
  'service.selectService': 'サービスを選択',
  'service.addToCart': 'カートに追加',
  'service.total': '合計',
  
  // Common
  'common.yes': 'はい',
  'common.no': 'いいえ',
  'common.cancel': 'キャンセル',
  'common.confirm': '確認',
  'common.delete': '削除',
  'common.edit': '編集',
  'common.save': '保存',
  'common.search': '検索',
  'common.loading': '読み込み中...',
  'common.noData': 'データなし',
  'common.actions': 'アクション',
  'common.status': 'ステータス',
  'common.date': '日付',
  'common.time': '時間',
  'common.total': '合計',
  'common.filter': 'フィルター',
  'common.export': 'エクスポート',
  'common.print': '印刷',
  'common.close': '閉じる',
  'common.back': '戻る',
  'common.next': 'Next',
  'common.previous': 'Previous',
  'common.submit': '送信',
  'common.reset': 'リセット',
  'common.create': '作成',
  'common.creating': '作成中...',
  'common.later': '後で',
  'common.clear': 'クリア',
  'common.copied': 'コピーしました！',
  'common.copyError': 'コピーに失敗しました',
  'common.autoDetected': '自動検出',
  'common.perPage': 'Per Page',
  'common.page': 'Page',
  'common.orders': 'Orders',
  'common.pieces': 'pieces',
  
  // Login
  'login.title': 'Cleandy',
  'login.subtitle': 'ドライクリーニング管理システム',
  'login.tenantId': '会社ID',
  'login.tenantPlaceholder': '会社ID（例：acme-clean）',
  'login.tenantIdHelp': '一意の会社識別子を入力してください',
  'login.continue': '続ける →',
  'login.notMember': 'まだメンバーではありませんか？',
  'login.startTrial': '無料トライアルを開始',
  'login.adminLogin': '🔒 管理者ログイン',
  'login.enterPin': 'PINコードを入力してください',
  'login.changeTenant': '会社を変更',
  'login.clear': 'クリア',
  'login.delete': '削除',
  'login.login': 'ログイン',
  'login.loggingIn': 'ログイン中...',
  'login.defaultPinOwner': 'デフォルトPIN：<strong>1234</strong>（オーナー）',
  'login.defaultPinCashier': 'デフォルトPIN：<strong>0000</strong>（レジ係）',
  'login.systemInitializing': 'システム初期化中...',
  'login.pinMinLength': 'PINは少なくとも4桁である必要があります',
  'login.invalidTenantId': '有効な会社IDを入力してください',
  'login.tenantNotFound': 'この会社コードが見つかりません。確認するか、新しいアカウントを作成してください。',
  'login.loginFailed': 'ログインに失敗しました',
  'login.welcome': 'ようこそ、{name}',
  'login.tagline': 'ドライクリーニングソフトウェア — ビジネスにスマートで簡単なソリューション',

  // Signup translations
  'signup.title': '無料トライアルを開始',
  'signup.subtitle': '15日間無料、クレジットカード不要',
  'signup.backToLogin': 'ログインページに戻る',
  'signup.companyCode': '会社コード',
  'signup.companyCodePlaceholder': '例：cleanpro',
  'signup.companyCodeHelp': 'このコードはシステムへのログインに使用されます',
  'signup.companyCodeMinLength': '会社コードは少なくとも3文字である必要があります',
  'signup.companyName': '会社名',
  'signup.companyNamePlaceholder': '会社名',
  'signup.companyNameRequired': '会社名は必須です',
  'signup.fullName': '氏名',
  'signup.fullNamePlaceholder': 'お名前',
  'signup.fullNameRequired': '氏名は必須です',
  'signup.phone': '電話番号',
  'signup.phonePlaceholder': '+81 90-1234-5678',
  'signup.validPhoneRequired': '有効な電話番号を入力してください',
  'signup.email': 'メール',
  'signup.emailPlaceholder': 'example@company.com',
  'signup.validEmailRequired': '有効なメールアドレスを入力してください',
  'signup.createAccount': 'アカウントを作成',
  'signup.creating': '作成中...',
  'signup.terms': 'アカウントを作成することで、利用規約とプライバシーポリシーに同意したことになります。',
  'signup.success': '登録が成功しました！ログイン情報がメールアドレスに送信されました。',
  'signup.successTitle': '登録成功！',
  'signup.successMessage': 'アカウントが正常に作成されました。',
  'signup.emailSent': 'ログイン情報がメールアドレスに送信されました。',
  'signup.redirecting': 'ログインページにリダイレクトしています...',
  'signup.startupPackageLoaded': 'スタートアップパッケージが読み込まれました！',
  'signup.products': '製品',
  'signup.customers': '顧客',
  'signup.users': 'ユーザー',
  'signup.demoDataReady': '✨ デモデータの準備ができました。すぐに使用を開始できます！',
  'signup.loginInfo': '📧 ログイン情報',
  'signup.loginInfoSent': '💡 この情報はメールアドレスにも送信されました',
  'signup.loginNow': '今すぐログイン →',
  'signup.hints.companyCode': 'ログインに使用',
  'signup.hints.country': '国は自動検出されました。別の国を選択できます。',
  'signup.freeTrial': '🎉 15日間無料お試し - クレジットカード不要！',
  'toast.productsLoadError': '製品の読み込みに失敗しました',
  'toast.statsLoadError': '統計の読み込みに失敗しました',
  'toast.orderDetailsLoadError': '注文詳細の読み込みに失敗しました',
  'toast.orderLoadError': '注文の読み込みに失敗しました',
  'toast.deliveryBeforeToday': 'お届け日は今日以降である必要があります',
  'toast.customerOpenOrders': '顧客には {count} 件の未完了の注文があります',
  'toast.customerDebt': '顧客には {amount} の負債があります',
  'toast.customerSaved': '顧客を保存しました',
  'toast.customerSaveError': '顧客の保存に失敗しました',
  'toast.customerUpdated': '顧客を更新しました',
  'toast.customerUpdateError': '顧客の更新に失敗しました',
  'toast.customerExistingSelected': '既存の顧客が選択されました',
  'toast.productAddedToCart': '製品をカートに追加しました',
  'toast.productAdded': '製品を追加しました',
  'toast.productDetailsUpdated': '製品詳細を更新しました',
  'toast.priceUpdated': '価格を更新しました',
  'toast.selectAtLeastOneService': '少なくとも1つのサービスを選択してください',
  'toast.selectCustomer': '顧客を選択してください',
  'toast.addProduct': '製品を追加してください',
  'toast.addressRequiredForDelivery': '宅配には顧客の住所が必要です',
  'toast.orderSaved': '注文を保存しました',
  'toast.orderSaveError': '注文の保存に失敗しました',
  'toast.cardPaymentSuccess': 'カード決済が成功しました！',
  'toast.cardPaymentError': 'カード決済に失敗しました',
  'toast.paymentFailedTryAgain': '決済に失敗しました。もう一度お試しください。',
  'toast.paymentStatusCheckFailed': '決済ステータスを確認できませんでした。',
  'toast.customerPhoneNotFound': '顧客の電話番号が見つかりません',
  'toast.whatsappSent': 'WhatsAppメッセージを送信しました！ ✅',
  'toast.whatsappFailed': 'WhatsAppメッセージを送信できませんでした',
  'toast.orderUpdateError': '注文の更新に失敗しました',
  'toast.searchError': '検索エラー',
  'toast.orderNotFound': '注文が見つかりません',
  'toast.editCancelled': '編集をキャンセルしました',
  'toast.noEditPermission': '過去の注文を編集する権限がありません',
  'toast.selectAtLeastOneOperation': '少なくとも1つの操作を選択してください',
  'toast.tailorAddedToCart': '仕立て操作をカートに追加しました',
  'toast.enterValidArea': '有効な面積を入力してください',
  'toast.enterValidAmount': '有効な金額を入力してください',
  'toast.amountExceedsRemaining': '金額は残高を超えることはできません',
  'toast.fillAllCardInfo': 'すべてのカード情報を入力してください',
  'toast.invalidCardNumber': '無効なカード番号',
  'toast.invalidMonth': '無効な月 (1-12である必要があります)',
  'toast.invalidYear': '無効な年',
  'toast.invalidCvc': '無効な CVC',

  // 不足している共通キー
  'common.allYears': '全年度',
  'common.autoDetected': '自動検出',
  'common.cancelled': 'キャンセル済み',
  'common.clear': 'クリア',
  'common.items': 'アイテム',
  'common.loadError': '読み込めません',
  'common.none': 'なし',
  'common.paid': '支払済み',
  'common.searchError': '検索エラー',
  'common.searchResults': '（検索結果）',
  'common.unit': '単位',
  'common.year': '年',

  // 口座明細
  'accountStatement.allTime': '全期間',
  'accountStatement.customer': '顧客',
  'accountStatement.customerReceipts': '顧客領収書',
  'accountStatement.noData': '口座明細が見つかりません',
  'accountStatement.noReceipts': '領収書が見つかりません',
  'accountStatement.payments': '支払い',
  'accountStatement.period': '期間',
  'accountStatement.printStatement': '明細を印刷',
  'accountStatement.receipts': '領収書',
  'accountStatement.remaining': '残高',
  'accountStatement.statement': '口座明細',
  'accountStatement.totalPaid': '合計支払額',

  // 属性
  'attributes.color': '色',
  'attributes.deleteError': '属性を削除できません',
  'attributes.deleted': '属性が削除されました',
  'attributes.name': '属性名',
  'attributes.noAttributes': '属性が定義されていません',
  'attributes.saveError': '属性を保存できません',
  'attributes.saved': '属性が保存されました',
  'attributes.value': '値',

  // 顧客明細
  'customerStatement.receiptDelivered': '配達済み',
  'customerStatement.receiptOpen': '未収',

  // 顧客
  'customers.add': '顧客を追加',
  'customers.adres': '住所',
  'customers.cannotDeleteWithOrders': '注文のある顧客は削除できません',
  'customers.legacyHidden': '非表示（旧）',
  'customers.notFound': '顧客が見つかりません',
  'customers.phoneMissing': '電話番号がありません',
  'customers.telefon': '電話',
  'customers.telefon2': '電話 2',

  // 損傷
  'damage.add': '損傷を追加',
  'damage.description': '説明',
  'damage.location': '場所',
  'damage.noPhoto': '写真なし',
  'damage.photo': '写真',
  'damage.saveError': '損傷レポートを保存できません',
  'damage.saved': '損傷レポートが保存されました',
  'damage.severity': '重大度',
  'damage.title': '損傷レポート',
  'damage.type': '損傷タイプ',

  // ダッシュボード
  'dashboard.allTime': '全期間',
  'dashboard.referral.button': '招待リンクをコピー',
  'dashboard.referral.desc': '招待した事業者が登録すると1か月延長！',
  'dashboard.referral.title': '友達を招待',

  // 配達
  'delivery.complete': '配達',
  'delivery.deliveredItems': '配達済みアイテム',
  'delivery.deliveredProducts': '配達済み商品',
  'delivery.error': '配達エラー',
  'delivery.noOrders': '注文が見つかりません',
  'delivery.success': '配達完了',

  // 配達リスト
  'deliveryList.address': '住所',
  'deliveryList.cancelButton': 'キャンセル',
  'deliveryList.cancelTitle': '注文をキャンセル',
  'deliveryList.complete': '完了',
  'deliveryList.completed': '完了済み',
  'deliveryList.delivered': '配達済み',
  'deliveryList.driver': 'ドライバー',
  'deliveryList.items': 'アイテム',
  'deliveryList.orderCancelled': '注文がキャンセルされました',
  'deliveryList.orderDelivered': '注文が配達されました',
  'deliveryList.pending': '保留中',
  'deliveryList.phone': '電話',
  'deliveryList.selectDriver': 'ドライバーを選択',
  'deliveryList.status': 'ステータス',
  'deliveryList.title': '配達リスト',

  // ドライバー
  'driver.searchHint': '2文字以上入力してください',
  'driver.searchPlaceholder': '領収書番号、名前または電話番号...',

  // フッター
  'footer.euServers': 'EUサーバー',
  'footer.gdpr': 'GDPR準拠',

  // 請求書
  'invoices.downloading': 'ダウンロード中...',

  // ログイン
  'login.credentialsTitle': '認証情報',
  'login.enterCredentials': '認証情報を入力',
  'login.forget': 'パスワードをお忘れですか？',
  'login.saveCredentialsNote': '認証情報が安全に保存されました',
  'login.tagline': 'クリーニング業向けソフトウェア — スマートで簡単なビジネスソリューション。',
  'login.usernamePlaceholder': 'ユーザー名を入力...',

  // メニュー
  'menu.driverPickup': 'ドライバー集荷',
  'menu.hardware': 'ハードウェア',
  'menu.payment': '支払い',
  'menu.reportsCharts': 'レポートとグラフ',

  // ナビゲーション
  'nav.logout': 'ログアウト',
  'nav.user': 'ユーザー',

  // 注文
  'order.amount': '金額',
  'order.homeDelivery': '宅配',
  'order.processing': '処理中...',
  'orderCreate.selectOperation': '作業を選択',
  'orderCreate.selectedOperations': '選択済み作業',

  // 支払い
  'payment.bank': '銀行振込',
  'payment.collect': '集金',
  'payment.credit': '掛払い',
  'payment.free': '無料',
  'payment.paymentCare': '口座払い',
  'payment.paymentsSaved': '支払いが保存されました',
  'payment.saveError': '支払いを保存できません',
  'payment.saved': '支払いが保存されました',
  'payment.split': '分割払い',

  // プレースホルダー
  'placeholder.customerAddress': '住所を入力...',
  'placeholder.customerEmail': 'メールを入力...',
  'placeholder.customerName': '名前を入力...',
  'placeholder.customerNotes': 'メモを入力...',
  'placeholder.customerPhone': '電話番号を入力...',

  // 価格設定
  'pricing.amount': '金額',
  'pricing.enterPrice': '価格を入力',
  'pricing.percent': 'パーセント',

  // 商品
  'product.damage': '損傷',
  'product.stain': 'シミ',

  // 領収書
  'receipt.addressLabel': '住所',
  'receipt.allYears': '全年度',
  'receipt.area': '面積',
  'receipt.backButton': '戻る',
  'receipt.buyCredits': 'クレジット購入',
  'receipt.cancelled': 'キャンセル済み',
  'receipt.cancelledBanner': 'この注文はキャンセルされました',
  'receipt.cancelledBy': 'キャンセル者',
  'receipt.cancelledDate': 'キャンセル日',
  'receipt.cancelledReason': 'キャンセル理由',
  'receipt.card': 'カード',
  'receipt.cash': '現金',
  'receipt.change': 'お釣り',
  'receipt.creditsFinished': 'WhatsAppクレジットが残りわずかです！',
  'receipt.customer': '顧客',
  'receipt.customerInfo': '顧客情報',
  'receipt.customerName': '顧客名',
  'receipt.deliveryDate': '配達日',
  'receipt.discount': '割引',
  'receipt.freeOfCharge': '無料',
  'receipt.generalTotal': '合計',
  'receipt.grandTotal': '最終合計',
  'receipt.homeDelivery': '宅配',
  'receipt.invalid': '無効な領収書',
  'receipt.items': 'アイテム',
  'receipt.label': 'ラベル',
  'receipt.markAsDelivered': '配達済みにする',
  'receipt.markAsReady': '準備完了にする',
  'receipt.messageFailed': 'メッセージ送信失敗',
  'receipt.messageSent': 'メッセージが送信されました！',
  'receipt.new': '新しい領収書',
  'receipt.noReceiptFound': '領収書が見つかりません',
  'receipt.notes': 'メモ',
  'receipt.onlyProEnterprise': 'Pro/Enterpriseのみ',
  'receipt.orderMarkedDelivered': '注文が配達済みに設定されました',
  'receipt.orderMarkedReady': '注文が準備完了に設定されました',
  'receipt.orderNumber': '注文番号',
  'receipt.paid': '支払済み',
  'receipt.partialPayment': '一部払い',
  'receipt.paymentMethod': '支払方法',
  'receipt.phone': '電話',
  'receipt.phoneNotFound': '電話番号が見つかりません',
  'receipt.piece': '点',
  'receipt.preview': 'プレビュー',
  'receipt.printError': '印刷エラー',
  'receipt.printerConnectError': 'プリンターに接続できません',
  'receipt.remaining': '残高',
  'receipt.remainingCredits': '残りクレジット',
  'receipt.reprint': '再印刷',
  'receipt.scanQR': 'QRコードをスキャン',
  'receipt.searchAll': 'すべて',
  'receipt.searchBy': '検索方法',
  'receipt.searchName': '顧客名',
  'receipt.searchPhone': '電話',
  'receipt.searchReceipt': '領収書番号',
  'receipt.searchTitle': '領収書を検索',
  'receipt.sessionNotFound': 'セッションが見つかりません。再度ログインしてください。',
  'receipt.status': 'ステータス',
  'receipt.thermalPrinter': 'サーマルプリンター',
  'receipt.thisReceiptCancelled': 'この領収書はキャンセルされました',
  'receipt.unknownError': '不明なエラー',
  'receipt.whatsappNotConnected': 'WhatsAppが接続されていません！',
  'receipt.year': '年',

  // レポート
  'reports.averageOrder': '平均注文',
  'reports.ordersCount': '注文数',
  'reports.salesReport': '売上レポート',
  'reports.totalSales': '総売上',

  // サービス
  'service.carpetShort': 'カーペット',
  'service.dryCleaningShort': 'ドライ',
  'service.ironingShort': 'アイロン',
  'service.shoeShineShort': '靴',
  'service.tailoringShort': '裁縫',
  'service.washingShort': '洗濯',

  // 設定
  'settings.africa': 'アフリカ',
  'settings.americas': '南北アメリカ',
  'settings.asia': 'アジア',
  'settings.asiaPacific': 'アジア太平洋',
  'settings.europe': 'ヨーロッパ',
  'settings.integrations': '統合',
  'settings.notifications': '通知',
  'settings.printer': 'プリンター',
  'settings.printerConnected': 'プリンター接続済み',
  'settings.printerNotConnected': 'プリンター未接続',
  'settings.printerSettings': 'プリンター設定',
  'settings.saveError': '設定を保存できません',
  'settings.saved': '設定が保存されました',
  'settings.testPrint': 'テスト印刷',
  'settings.turkey': 'トルコ',

  // サインアップ
  'signup.errors.companyCodeRequired': '会社コードは必須です',
  'signup.errors.companyNameRequired': '会社名は必須です',
  'signup.errors.emailInvalid': '無効なメールアドレス',
  'signup.errors.emailRequired': 'メールは必須です',
  'signup.errors.ownerNameRequired': 'オーナー名は必須です',
  'signup.errors.signupFailed': '登録に失敗しました',
  'signup.referral.bonus': '紹介ボーナス',
  'signup.referral.title': '招待コード',

  // ステータス
  'status.cancelled': 'キャンセル済み',
  'status.delivered': '配達済み',
  'status.pending': '保留中',
  'status.pickup_in_progress': '集荷中',
  'status.pickup_pending': '集荷待ち',
  'status.ready': '準備完了',
  'status.received': '受付済み',

  // サブスクリプション
  'subscription.buyNow': '今すぐ購入',
  'subscription.cancel': 'サブスクをキャンセル',
  'subscription.contactSupport': 'サポートに連絡',
  'subscription.currentPlan': '現在のプラン',
  'subscription.currentUsage': '現在の使用量',
  'subscription.daysLeft': '日残り',
  'subscription.endDate': '終了日',
  'subscription.expired': '期限切れ',
  'subscription.expiresOn': '有効期限',
  'subscription.features': '機能',
  'subscription.loading': 'サブスクリプション読み込み中...',
  'subscription.monthly': '月次',
  'subscription.monthlyLimit': '月次制限',
  'subscription.noSubscription': 'アクティブなサブスクリプションなし',
  'subscription.payNow': '今すぐ支払う',
  'subscription.plan': 'プラン',
  'subscription.pro': 'Pro',
  'subscription.renew': '更新',
  'subscription.renewNow': '今すぐ更新',
  'subscription.startDate': '開始日',
  'subscription.title': 'サブスクリプション',
  'subscription.trial': 'トライアル',
  'subscription.trialDaysLeft': 'トライアル日残り',
  'subscription.upgrade': 'アップグレード',
  'subscription.yearly': '年次',

  // サポートチケット
  'tickets.title': 'サポートチケット',
  'tickets.newTicket': '新しいチケット',
  'tickets.noTickets': 'チケットが見つかりません',
  'tickets.subject': '件名',
  'tickets.description': '説明',
  'tickets.created': 'サポートチケットが作成されました',
  'tickets.createError': 'チケットを作成できません',
  'tickets.loadError': 'チケットを読み込めません',
  'tickets.messages': 'メッセージ',
  'tickets.typeMessage': 'メッセージを入力...',
  'tickets.closed': 'クローズ済み',
  'tickets.admin': '管理者',
  'tickets.ratingSubmitted': '評価が保存されました。ありがとう！',
  'tickets.translationError': '翻訳エラー',
  'tickets.status.open': 'オープン',
  'tickets.status.closed': 'クローズ',
  'tickets.rating.veryBad': '非常に悪い',
  'tickets.rating.bad': '悪い',
  'tickets.rating.okay': '普通',
  'tickets.rating.good': '良い',
  'tickets.rating.excellent': '非常に良い',

  // Toast通知
  'toast.logoTooLarge': 'ロゴファイルが大きすぎます',
  'toast.logoUploadError': 'ロゴをアップロードできません',
  'toast.uploadingLogo': 'ロゴをアップロード中...',

  // WhatsApp
  'whatsapp.title': 'WhatsApp',
  'whatsapp.connect': 'WhatsAppに接続',
  'whatsapp.disconnect': '切断',
  'whatsapp.connected': '接続済み',
  'whatsapp.scanQR': 'QRコードをスキャン',
  'whatsapp.status': 'ステータス',
  'whatsapp.credits': 'クレジット',
  'whatsapp.buyCredits': 'クレジット購入',
  'whatsapp.creditPackages': 'クレジットパッケージ',
  'whatsapp.messages': 'メッセージ',
  'whatsapp.creditsRemaining': 'クレジット残り',
  'whatsapp.noCredits': 'クレジットがありません',
  'whatsapp.sendTest': 'テストメッセージ送信',
  'whatsapp.testSent': 'テストメッセージが送信されました',
  'whatsapp.testFailed': 'テストメッセージの送信に失敗',
  'whatsapp.templates': 'テンプレート',
  'whatsapp.template': 'テンプレート',
  'whatsapp.preview': 'プレビュー',
  'whatsapp.save': 'テンプレートを保存',
  'whatsapp.saved': 'テンプレートが保存されました',
  'whatsapp.orderReady': '注文準備完了',
  'whatsapp.orderDelivered': '注文配達済み',
  'whatsapp.receiptCreated': '領収書が作成されました',

  // Zレポート
  'zReport.title': 'Zレポート',
  'zReport.byEmployee': '従業員別',
  'zReport.byProduct': '商品別',
  'zReport.byService': 'サービス別',
  'zReport.cardPayments': 'カード払い',
  'zReport.cashIn': '収入',
  'zReport.cashOut': '支出',
  'zReport.cashPayments': '現金払い',
  'zReport.closingBalance': '締め残高',
  'zReport.creditPayments': '掛払い',
  'zReport.custom': 'カスタム',
  'zReport.daily': '日次',
  'zReport.endDate': '終了日',
  'zReport.freeOrders': '無料注文',
  'zReport.generateReport': 'レポートを生成',
  'zReport.monthly': '月次',
  'zReport.newCustomers': '新規顧客',
  'zReport.openingBalance': '開始残高',
  'zReport.printReport': 'レポートを印刷',
  'zReport.returningCustomers': 'リピーター',
  'zReport.selectDate': '日付を選択',
  'zReport.serviceBreakdown': 'サービス別内訳',
  'zReport.startDate': '開始日',
  'zReport.totalCollected': '総回収額',
  'zReport.totalItems': '総アイテム数',
  'zReport.totalOrders': '総注文数',
  'zReport.totalRefunds': '総返金額',
  'zReport.totalRevenue': '総収益',
  'zReport.transferPayments': '振込払い',
  'zReport.weekly': '週次',
  'zreport.card': 'カード',
  'zreport.cash': '現金',
  'zreport.date': '日付',
  'zreport.orders': '注文',
  'zreport.print': '印刷',
  'zreport.title': 'Zレポート',
  'zreport.total': '合計',

  'zReport.cashBoxStartNote': 'レジ開始残高',
  'zReport.todayCashNote': '本日受取現金',
  'zReport.branchCollectionsNote': '自店+他店舗回収',
  'zReport.dailyExpensesNote': '本日の経費',
  'customerCard.balanceZero': '残高はすでにゼロです。',
  'customerCard.debtLabel': '負債が消去されます',
  'customerCard.creditLabel': 'クレジットが消去されます',
  'customerCard.resetConfirm': '残高がリセットされます（{label}）。確認しますか？',
  'customerCard.resetSuccess': '残高がリセットされました',
  'customerCard.resetError': '残高をリセットできませんでした',
  'customerCard.printTitle': '顧客カード',
  'customerCard.heading': '顧客カード',
  'customerCard.tel1': '電話 1',
  'customerCard.tel2': '電話 2',
  'customerCard.address': '住所',
  'customerCard.printButton': '顧客カードを印刷',
  'customerCard.resetting': 'リセット中...',
  'customerCard.resetBalance': '残高をリセット',
  'tailoring.loadError': '価格を読み込めませんでした',
  'tailoring.nameRequired': '操作名を入力してください',
  'tailoring.invalidPrice': '有効な価格を入力してください',
  'tailoring.addSuccess': '新しい仕立て操作が追加されました！',
  'tailoring.saveError': '保存エラー',
  'tailoring.deleteConfirm': 'この操作を削除してもよろしいですか？',
  'tailoring.deleteSuccess': '操作が削除されました',
  'tailoring.deleteError': '削除エラー',
  'tailoring.saveSuccess': '仕立て価格が保存されました！',
  'tailoring.addNewTitle': '新しい仕立て操作を追加',
  'tailoring.operationNameLabel': '操作名',
  'tailoring.priceLabel': '価格',
  'tailoring.iconLabel': 'アイコン（絵文字）',
  'tailoring.operationNamePlaceholder': '例：えり縫い',
  'tailoring.savePricesHint': '保存をクリックして価格を保存',
  'tailoring.addCustomHint': '+ボタンを使ってカスタム操作を追加',
  'reportsList.title': '領収書リストレポート',
  'reportsList.startDate': '開始日',
  'reportsList.endDate': '終了日',
  'reportsList.search': '検索',
  'reportsList.loading': '読み込み中...',
  'reportsList.description': 'この期間に登録または配達されたすべての領収書が表示されます',
  'reportsList.empty': 'この期間に領収書が見つかりませんでした',
  'reportsList.changeDateRange': '別の期間を選択してください',
  'reportsList.categoryBreakdown': 'カテゴリ別分布',
  'reportsList.unknown': '不明',
  'reportsList.cancelReason': 'キャンセル理由：',
  'reportsList.excelDownloaded': 'Excelファイルがダウンロードされました',
  'reportsList.excelError': 'Excelファイルを作成できませんでした',
  'reportsList.totalReceipt': '総領収書数',
  'reportsList.activeReceipt': 'アクティブな領収書',
  'reportsList.loadError': '領収書リストを読み込めませんでした',
  'reportsList.dateError': '開始日は終了日より後にできません',
  'charts.revenue': '売上',
  'charts.orders': '注文',
  'charts.pieces': '点数',
  'charts.receipts': '領収書数',
  'charts.loadError': 'データを読み込めませんでした',

  'customerStatement.selectDateRange': '期間を選択',
  'customerStatement.thisMonth': '今月',
  'customerStatement.lastMonth': '先月',
  'customerStatement.allTime': '全期間',
  'customerStatement.startDate': '開始日',
  'customerStatement.endDate': '終了日',
  'customerStatement.printPDF': '明細書を印刷 (PDF)',
  'customerStatement.title': '取引明細書',
  'customerStatement.customerName': '顧客名',
  'customerStatement.phone': '電話',
  'customerStatement.address': '住所',
  'customerStatement.openingBalance': '期首残高',
  'customerStatement.closingBalance': '期末残高',
  'customerStatement.description': '摘要',
  'customerStatement.type': '種類',
  'customerStatement.debit': '借方',
  'customerStatement.credit': '貸方',
  'customerStatement.total': '合計',
  'customerStatement.cancelled': 'キャンセル',
  'customerStatement.payment': '支払い',
  'customerStatement.items': '件',
  'customerStatement.noTransactions': '選択した期間の取引はありません。',
  'customerStatement.statementDate': '明細日付',

  'tailoring.title': '仕立てサービス',
  'tailoring.addNew': '新しい操作',
  'tailoring.subtitle': 'こちらで仕立てサービスの料金を更新できます',
  'tailoring.addNewDescription': 'カスタム仕立て操作タイプを追加する',
  'tailoring.add': '追加',
  'tailoring.savePrices': '料金を保存',
  'tailoring.default': 'デフォルト',
  'tailoring.infoTitle': '情報',
  'tailoring.info1': '料金変更後、「料金を保存」をクリックしてください',
  'tailoring.info2': '「新しい操作」ボタンでカスタム操作タイプを追加できます',
  'tailoring.info3': 'カスタム操作はゴミ箱アイコンで削除できます',
  'tailoring.info4': 'これらの料金は仕立てサービス付き注文作成時に使用されます',
  'tailoring.info5': '各仕立て操作に個別の料金を設定できます',
  'tailoring.info6': 'カートに追加する際に料金が自動計算されます',

  'hardware.title': 'ハードウェアショップ',
  'hardware.subtitle': 'レシートプリンター、ラベルプリンター、発信者番号通知機器',
  'hardware.cart': 'カート',
  'hardware.infoTitle': '情報',
  'hardware.infoText': 'これらのハードウェア製品は現在トルコでのみ購入可能です。他の国では情報目的でリストされています。',
  'hardware.myCart': 'マイカート',
  'hardware.cartEmpty': 'カートは空です',
  'hardware.vatSuffix': '+ 消費税',
  'hardware.total': '合計',
  'hardware.checkout': '支払いへ進む',
  'hardware.receiptPrinters': 'レシートプリンター',
  'hardware.receiptPrintersSubtitle': '80mm感熱プリンター、オートカッター付き',
  'hardware.compatibilityTitle': 'CleandySoft対応',
  'hardware.receiptCompatText': 'オートカッター付きの80mm感熱プリンターすべてに対応。',
  'hardware.labelPrinters': 'ラベルプリンター',
  'hardware.labelPrintersSubtitle': 'ドットマトリクスプリンター、76mm/57mm (Epson TM-U220, Bixolon SRP-270)',
  'hardware.testedModels': 'テスト済みモデル',
  'hardware.labelCompatText': 'Epson TM-U220とBixolon SRP-270でテスト済み。他ブランド・モデルは問題が生じる場合があります。',
  'hardware.callerIdTitle': '発信者番号通知機器',
  'hardware.callerIdSubtitle': '顧客からの着信識別',
  'hardware.compatibilityNote': '互換性メモ',
  'hardware.callerIdCompatText': 'CIDShow 2ラインモデルのみテスト済み。他ブランド・モデルは動作する可能性がありますが保証されません。',
  'hardware.barcodeScanners': 'バーコードスキャナー',
  'hardware.barcodeScannerSubtitle': 'USB バーコード・QRコードスキャナー',
  'hardware.barcodeCompatText': 'すべての2DバーコードスキャナーはCleandySoftで使用可能。USB HIDモードのスキャナーは自動対応。',
  'hardware.driverDownloads': 'ドライバー・ソフトウェアダウンロード',
  'hardware.driverDownloadsText': 'プリンターを接続する前に適切なドライバーをダウンロードすることをお勧めします。',
  'hardware.onlyTurkey': 'この製品はトルコでのみ購入可能です',
  'hardware.addedToCart': 'カートに追加しました！',
  'hardware.available': '在庫あり',
  'hardware.info': '情報',
  'hardware.features': '特長',
  'hardware.addToCart': 'カートに追加',
  'hardware.infoOnly': '参考情報のみ',
  'expenses.expenseType': '経費種類',
  'expenses.allBranches': 'すべての支店',
  'expenses.noBranch': '支店なし',
  'expenses.allTypes': 'すべての種類',
  'expenses.categoryBy': 'カテゴリ別',
  'expenses.records': '件',
  'expenses.exportExcel': 'Excel',
  'expenses.excelError': 'Excelファイルを作成できませんでした',
  'expenses.branchSelect': '支店を選択',
  'expenses.noBranchSelected': '— 支店未選択 —',
  'expenses.myBranch': '私の支店',
  'expenses.canOnlyDeleteToday': '本日入力した経費のみ削除できます。',
  'subscription.referralDesc': '招待した友人が登録して会員になると、1か月延長されます！招待を送るだけでは対象になりません。',
};
